export default {
  bellHeart: () => import('./bell-heart.json'),
};
